// condition
// {
//   order: "asc"|"desc",
//   page: 0,
//   rowsPerPage: 10,
//   sort: "filed name"
// }

export const handleTableQuery = (tableData, condition) => {
  const { order, page, rowsPerPage, sort } = condition;
  const tableSort = stableSort(tableData, getComparator(order, sort));
  const tableSlice = tableSort.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  )
  return tableSort;
}

// 取得排序方式
const getComparator = (order, sort) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, sort) // 降冪排序
    : (a, b) => -descendingComparator(a, b, sort); //升冪排序
}

// 降冪排序或升冪排序
const descendingComparator = (a, b, sort) => {
  if (b[sort] < a[sort]) {
    return -1;
  }
  if (b[sort] > a[sort]) {
    return 1;
  }
  return 0;
}

// 排序資料
const stableSort = (tableData, comparator) => {
  const sortData = tableData.map((el, index) => [el, index]);
  sortData.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  })
  return sortData.map((el) => el[0]);
}